module.exports = __webpack_public_path__ + "fonts/webdatarocks-icons.c724f978.woff";